module.exports = __webpack_public_path__ + "img/brown1.9b68b18d.jpg";